query publicFilterJob($id: ID!) {
  publicFilterJob(id: $id) {
    resultImageUrl
  }
}
